<template>
  <div>
    <nav-bar :title="getNavBarName"></nav-bar>
    <congrats-modal
      :coins="coinsInfo.coins"
      :points="coinsInfo.points"
      :description="coinsInfo.description"
    ></congrats-modal>
    <div class="mobile pt-4">
      <b-container>
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <project-tasks-skeleton> </project-tasks-skeleton>
          </template>
          <div>
            <b-row class="m-0">
              <b-col sm="12" md="5" lg="5" class="p-0">
                <div class="filter--button" @click="showOrCloseModal">
                  <span class="material-icons filter--button__icon">filter_list</span>
                  <p class="filter--button__text m-0">Filter</p>
                </div>
              </b-col>
              <task-filter
                :isProject="true"
                :priorities="priorities"
                :priorityFilter="prioritySelected"
                :dueDateFilter="dueDate"
                :openModal="showModal"
                @onCloseModal="showOrCloseModal"
                @filterApplied="sendFilterController"
              >
              </task-filter>
            </b-row>
            <task-list
              v-if="!!Object.keys(allTasks).length"
              :tasks="allTasks"
              class="taksList"
              @reloadTasksStatuses="() => this.initialLoadData(this.queryParamsBase)"
              @showCongratsModal="showCongratsModal"
            ></task-list>
            <div v-else class="text-center mx-2 mt-5">
              <i class="material-icons border-2 full-icon rounded-circle align-middle border-0">
                assignment
              </i>
              <p class="h4 text-xmuted mx-4 mt-3">
                You have no tasks
              </p>
            </div>
            <b-button @click="addTasks" pill class="float-button-right rounded-circle p-1 bg-main">
              <i class="material-icons big-icon  align-middle text-light">add</i>
            </b-button>
          </div>
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { getAllTasks } from '@/myTasks/services/';
import { useSessionStore } from '@/common';
import { NavBar } from '@/common/components';
import taskFilter from '@/myTasks/components/TaskFilter';
import ProjectTasksSkeleton from '@/myTasks/components/skeletons/ProjectTasksSkeleton';
import taskList from '@/myTasks/components/TasksList';
import CongratsModal from '@/components/Congrats/CongratsModal';

export default {
  components: {
    NavBar,
    ProjectTasksSkeleton,
    taskList,
    taskFilter,
    CongratsModal,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      loading: false,
      showModal: false,
      allTasks: {},
      priorities: [],
      project: {},
      prioritySelected: {},
      dueDate: '',
      sessionStore,
      coinsInfo: {
        description: '',
        coins: 0,
        points: 0,
      },
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    getChildId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
    getProjectId() {
      return this.$route.params.projectId;
    },
    getProjectName() {
      return this.$route.params.projectName;
    },
    getNavBarName() {
      return `${this.getProjectName} Project`;
    },
    queryParamsBase() {
      return {
        type: 1,
        by_category: true,
        by_due_date: true,
        project: this.getProjectId,
      };
    },
    tasksArrayToObject() {
      return (tasks) => {
        return Object.fromEntries(tasks.map((taskGroup) => [taskGroup.state_id, taskGroup]));
      };
    },
  },
  methods: {
    addTasks() {
      this.$router.push({
        name: 'new-project-task',
        params: {
          projectId: this.getProjectId,
          projectName: this.getProjectName,
        },
      });
    },
    async handleTaskFilter(priority, due_date) {
      const queryParams = {
        ...this.queryParamsBase,
        priority: priority,
        due_date,
      };
      this.initialLoadData(queryParams);
    },
    async getTasks(queryParams) {
      const { tasks, priorities } = await getAllTasks(this.getChildId, queryParams);
      this.allTasks = this.tasksArrayToObject(tasks);
      this.priorities = priorities;
    },
    sendFilterController(data) {
      this.showOrCloseModal();
      this.prioritySelected.id = data.priority || '';
      this.dueDate = data.due_date;
      this.handleTaskFilter(this.prioritySelected.id, this.dueDate);
    },
    showOrCloseModal() {
      this.showModal = !this.showModal;
    },
    async initialLoadData(queryParams) {
      this.loading = true;
      try {
        await this.getTasks(queryParams);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    showCongratsModal(coinsInfo) {
      if (this.userIsAParent) return;
      this.coinsInfo = coinsInfo;
      this.$bvModal.show('congrats-modal');
    },
  },
  async mounted() {
    this.initialLoadData(this.queryParamsBase);
  },
};
</script>

<style lang="scss" scoped>
.filter--button {
  margin: 1rem 0;
  color: var(--color-main);
  display: flex;

  &__icon {
    margin-right: 12px;
  }
}
.taksList {
  overflow: scroll;
  height: 100%;
}
</style>
